module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-disney-district-in-fullerton-california-e665e2a319159db56718223df9c620a2.png";